
import { EditForManyProjectProposal } from 'features/Council/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function EditCouncilForManyProjectProposalPage() {

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <EditForManyProjectProposal />

      </Layout>
    </LayoutProvider>
  );
}

export default EditCouncilForManyProjectProposalPage;
